import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";
import { Loader, Dimmer } from "semantic-ui-react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import axios from "axios";
import useTableScroll from "../components/useTableScroll";

const CatalogoSistema = ({ show, idfranquicia, onHide }) => {
  let op = require("../../public/modulos/datos");
  const btnAcepta = useRef();
  const btnCancela = useRef();
  const txtCliente = useRef([]);
  const txtBuscar = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [listaAfiliados, setListaAfiliados] = useState([]);
  const [afiliadosTodos, setAfiliadosTodos] = useState([]);
  let values = {
    idorganizacion: "",
    rif: "",
    nombre: "",
    logo: "athos.png",
  };

  const headCells = [
    { label: "ID", textAlign: "center" },
    { label: "RIF", textAlign: "center" },
    { label: "NOMBRE", textAlign: "center" },
  ];

  const { TblContainer, TblHead } = useTableScroll(headCells);
  const handleSearch = (e) => {
    let target = e.target;
    let lista = [];

    if (target.value === "") {
      lista = afiliadosTodos;
    } else {
      lista = afiliadosTodos.filter((x) => {
        if (
          x.idorganizacion.includes(target.value) ||
          x.rif.includes(target.value) ||
          x.nombre.toLowerCase().includes(target.value.toLowerCase())
        ) {
          return x;
        }
      });
    }

    setListaAfiliados(lista);
  };

  const seleccionarRegistros = (id) => {
    const endpoint = `${op.conexion}/api/athos/organizacion/obtener?idfranquicia=${id}`;

    setActivate(true);

    axios
      .get(endpoint)
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            console.log(response.data);

            setListaAfiliados(response.data);
            setAfiliadosTodos(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setListaAfiliados([]);
    setAfiliadosTodos([]);
    values = {
      idorganizacion: "",
      rif: "",
      nombre: "",
      logo: "athos.png",
    };
  };

  const seleccionarFila = (item, index) => {
    values = {
      idorganizacion: item.idorganizacion,
      rif: item.rif,
      nombre: item.nombre,
      logo: item.logo,
    };

    for (let i = 0; i < txtCliente.current.length; i++) {
      if (i === index) {
        txtCliente.current[i].style.backgroundColor = "lightskyblue";
      } else {
        if (txtCliente.current[i]) {
          txtCliente.current[i].style.backgroundColor = "white";
        }
      }
    }

    btnAcepta.current.focus();
  };

  const cancelar = () => {
    blanquear();
    onHide();
  };

  const seleccionarAfiliados = () => {
    onHide(values);
  };

  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        blanquear();
        seleccionarRegistros(idfranquicia);
        txtBuscar.current.focus();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3></h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} inverted>
          <Loader inverted>Cargando...</Loader>
        </Dimmer>
        <div className="col-md-12" style={{ marginBottom: "10px" }}>
          <div className="row">
            <div className="input-group col-md-6 input-group-sm mb-3">
              <input
                type="text"
                onChange={handleSearch}
                className="form-control text-uppercase"
                ref={txtBuscar}
              />
              <button
                className="btn btn-info"
                style={{ pointerEvents: "none" }}
              >
                <i className="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer
            container={{
              height: 200,
              width: "100%",
              overflow: "auto",
              padding: "2px",
              fontSizeAdjust: "0.6",
            }}
          >
            <TblHead />

            <TableBody>
              {listaAfiliados &&
                listaAfiliados.map((item, index) => (
                  <TableRow
                    key={index}
                    ref={(el) => (txtCliente.current[index] = el)}
                    style={{ backgroundColor: "white" }}
                    onClick={() => seleccionarFila(item, index)}
                  >
                    <TableCell className="py-2 text-center">
                      {item.idorganizacion}
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {item.rif}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.nombre}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          className="btn btn-sm btn-success rounded-pill"
          style={{ margin: "5px" }}
          onClick={seleccionarAfiliados}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoSistema;



// WEBPACK FOOTER //
// ./src/catalogosAthos/catalogoSistema.js